module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_nosetochin.48c5b370.jpg";